import { EntityMediaFragment } from '@/features/messages/graphql/fragments/generated/MediaType';
import { UserFragment } from '@/graphql/fragments/generated/User';
import { ClientType, FileSchema, StageConfigSchema, StatusCategoryEnum } from '@/types/schema';

export enum ProjectActions {
  Edit = 'EDIT',
  Delete = 'DELETE',
  Duplicate = 'DUPLICATE',
  ManageSyncedTasks = 'MANAGE_SYNCED_TASKS',
}

export enum ProjectDashboardTabs {
  AllTasks = 'all-tasks',
  Discussions = 'discussions',
  Files = 'files',
  ActivityFeed = 'activity-feed',
  Insights = 'insights',
}

export interface ProjectsTableRowData
  extends Pick<FileSchema, 'id' | 'name' | 'projectStatus' | 'dueDate'> {
  media?: EntityMediaFragment;
  stages?: Pick<StageConfigSchema, 'progress'>[];
  progress?: ProjectProgressType;
  projectOwner?: UserFragment;
  clients?: Array<
    Pick<ClientType, 'id' | 'clientName'> & { clientIcon?: EntityMediaFragment | null }
  >;
}

/**
 * number is an absolute, un-normalized integer
 */
export type ProjectProgressType = Record<StatusCategoryEnum, number>;
